import { NgModule } from '@angular/core';
import { SharedFeaturesModule } from '@src/app/shared_features/shared-features.module';
import { SharedModule } from '@src/app/shared_components/shared.module';
import { RegisterComponent } from './register/register.component';
import { LoginComponent } from './login/login.component';
import { HomeComponent } from './dashboard/home.component';
import { StatsCardComponent } from './dashboard/common/stats-card/stats-card.component';

@NgModule({
    imports: [SharedFeaturesModule, SharedModule],
    declarations: [HomeComponent, LoginComponent, RegisterComponent, StatsCardComponent],
    exports: [HomeComponent, LoginComponent, StatsCardComponent],
})
export class LayoutModule {}
